function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#c98d09",
  d: "M33 4l-2 2 1 1a2 2 0 11-2 2l-1-1-2 2 5 5 6-6-5-5z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffc107",
  d: "M22.586 23.586l17-17 2.828 2.828-17 17z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffc107",
  d: "M18 44c-3.542 0-6.478-2.645-6.938-6.063C7.645 37.478 5 34.542 5 31c0-3.426 2.594-6.158 6.607-6.961C16.743 23.012 23.706 23 24 23h2v2c0 .294-.012 7.257-1.039 12.393C24.158 41.406 21.426 44 18 44zm3.96-16.96c-2.393.076-6.43.294-9.567.921C11.597 28.12 9 28.811 9 31c0 1.654 1.346 3 3 3h3v3c0 1.654 1.346 3 3 3 2.189 0 2.88-2.597 3.039-3.393.627-3.137.846-7.174.921-9.567z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#c98d09",
  d: "M27 28a.997.997 0 01-.707-.293l-5-5a.999.999 0 111.414-1.414l5 5A.999.999 0 0127 28z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#c98d09",
  d: "M27.99 27.01a.997.997 0 01-.707-.293l-5-5a.999.999 0 111.414-1.414l5 5a.999.999 0 01-.707 1.707z"
});

var Svg2MasterKey = function Svg2MasterKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg2MasterKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2-master-key.4af06d5e.svg";
export { ForwardRef as ReactComponent };